
import { defineComponent } from "vue";
import { GetLegendItems } from "@/utils";
export default defineComponent({
  props: ["series", "data", "dataProp"],
  setup(props) {
    const legend = GetLegendItems(props.series, props.data, props.dataProp);
    return {
      legend,
    };
  },
});
